import RenameFolderModal from "./RenameFolderModal";

export default RenameFolderModal;
